import React from 'react';
import styled from 'styled-components';
import {getLocale} from '@epic-core/common';
import {AccentColorOptions} from 'epic-ue-theme';
import {modifyRichTextContent} from './RichTextSpan.utils';

const getRadialGradient = (from, to) =>
    `radial-gradient(100% 185.14% at 100% 100%, ${from} 0%, ${to} 100%)`;

const RichTextSpanWrap = styled.span<{accentcolor: AccentColorOptions}>`
    && {
        &.loc-ko {
            word-wrap: break-word;
            word-break: keep-all;
        }

        a {
            color: ${(p) => p.theme.palette.accent[p.accentcolor]};
            text-decoration: none;
            line-height: initial;
            background-image: ${(p) =>
                getRadialGradient(
                    p.theme.palette.gradient[p.accentcolor].from,
                    p.theme.palette.gradient[p.accentcolor].to
                )};
            background-position: 0% 100%;
            background-repeat: no-repeat;
            background-size: 0% 2px;
            padding-bottom: 2px;
            margin-bottom: -2px;
            &:hover {
                color: unset;
                animation: underline 1.8s infinite;
                @media (prefers-reduced-motion: reduce) {
                    animation: none;
                    background-size: 100% 2px;
                }
                @keyframes underline {
                    0% {
                        background-size: 10% 2px;
                    }
                    50% {
                        background-size: 100% 2px;
                    }
                    100% {
                        background-size: 100% 2px;
                    }
                }
            }
            &:focus-visible {
                outline: 1px solid ${(p) => p.theme.palette.misc.outline};
                outline-offset: 2px;
            }
        }
        p:first-of-type {
            margin-block-start: initial;
        }
        p:last-of-type {
            margin-block-end: initial;
        }
    }
`;

export interface RichTextSpanProps {
    richText?: string;
    className?: string;
    accentColor?: AccentColorOptions;
}

export const RichTextSpan = (props: RichTextSpanProps): JSX.Element => {
    const {richText, className, accentColor = 'sky'} = props;
    const modifiedRichText = modifyRichTextContent(richText);

    return (
        <RichTextSpanWrap
            dangerouslySetInnerHTML={{__html: modifiedRichText || ''}}
            className={`ue-rich-text ${className || ''} loc-${getLocale()}`}
            accentcolor={accentColor}
        />
    );
};
